var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXdc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B8B5B1",
    d: "M18.84 11.336c-1.577-9.116-13.483-7.35-13.697 0l1.122.578s-.364.215-1.122.712c1.38 8.948 13.092 7.646 13.714-.013q-.574-.352-1.153-.699zm-5.872 3.188l-1.118-1.928l-1.123 1.928l-.866-.064l1.624-2.73l-1.457-2.348l.879-.078l1.028 1.745l1.038-1.672l.814.017l-1.346 2.323l1.5 2.777l-.968.03z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#254C82",
    d: "M18.278 10.972c-2.138-8.1-11.923-5.915-12.591 0l1.671.942l-1.671 1.063c1.457 7.796 12.017 6.292 12.591-.017c-1.058-.668-1.697-1.063-1.697-1.063s1.44-.771 1.697-.925m-5.305 3.565L11.85 12.61l-1.14 1.928l-.866-.06l1.629-2.73l-1.458-2.353l.879-.072l1.029 1.744l1.032-1.672l.819.018l-1.346 2.318l1.517 2.777l-.968.03z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXdc);
export default __webpack_public_path__ + "static/media/xdc.35cb1567894e50bc7d3fd2957a19461a.svg";
export { ForwardRef as ReactComponent };